var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.352 11.23A14.092 14.092 0 0112.5 13c-2.407 0-4.776-.612-6.852-1.77A13.785 13.785 0 011 7a13.785 13.785 0 014.648-4.23A14.092 14.092 0 0112.5 1c2.407 0 4.776.612 6.852 1.77A13.785 13.785 0 0124 7a13.785 13.785 0 01-4.648 4.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.617 9.48c-1.43 0-2.593-1.113-2.593-2.48 0-1.365 1.159-2.476 2.586-2.48a2.096 2.096 0 00-.025.319c0 1.209 1.029 2.192 2.293 2.192.112 0 .223-.008.333-.024-.004 1.364-1.166 2.473-2.594 2.473z"
  }))));
}
export default SvgEye;